var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "order-detail-dialog",
      attrs: {
        title: "订单详情",
        visible: _vm.visible,
        width: "90%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "order-detail-content",
        },
        [
          _c(
            "el-card",
            { staticClass: "detail-section", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "section-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("基础信息"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("订单编号："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.orderNo || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("下单时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.orderTime || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("支付时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.paymentTime || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("预订人："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.orderDetail.reservationName ||
                              _vm.orderDetail.bookerName ||
                              "-"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("预订手机号："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.reservationPhone || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.showReservationDate
                    ? _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("预订日期："),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.reservationDateDisplay)),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("客户备注："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value remark" }, [
                        _vm._v(_vm._s(_vm.orderDetail.remark || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "info-item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("订单状态："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getOrderStatusType(
                                _vm.orderDetail.orderStatus
                              ),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.orderDetail.orderStatus || "-") +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "info-item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("是否核销："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                _vm.orderDetail.writeOffTime !== null &&
                                _vm.orderDetail.writeOffTime !== undefined
                                  ? "success"
                                  : "info",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.orderDetail.writeOffTime !== null &&
                                    _vm.orderDetail.writeOffTime !== undefined
                                    ? "是"
                                    : "否"
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("成交小程序："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.customerName || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("游客信息："),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "traveler-list" },
                        [
                          !(_vm.orderDetail.travelerList || []).length
                            ? _c("span", { staticClass: "value" }, [
                                _vm._v("-"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(
                            _vm.orderDetail.travelerList,
                            function (traveler, index) {
                              return _c(
                                "span",
                                { key: index, staticClass: "traveler-item" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(traveler.name || "-") +
                                      " / " +
                                      _vm._s(traveler.idCard || "-") +
                                      "\n              "
                                  ),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "detail-section", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "section-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("商品明细"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.orderDetail.orderItems || [],
                    border: "",
                    size: "small",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "skuId", label: "skuId", width: "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "productName",
                      label: "商品名称",
                      "min-width": "150",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "merchantName",
                      label: "所属商户",
                      "min-width": "150",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: "所属门店",
                      "min-width": "150",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.orderDetail.storeName || "-") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "categoryName",
                      label: "商品分类",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "quantity",
                      label: "数量",
                      width: "80",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unitPrice",
                      label: "单价",
                      width: "100",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            ¥" +
                                _vm._s(scope.row.otPrice) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalPrice",
                      label: "总价",
                      width: "100",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            ¥" +
                                _vm._s(scope.row.otPrice * scope.row.quantity) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "图片", width: "80", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.imageUrl
                              ? _c("el-image", {
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                    cursor: "pointer",
                                  },
                                  attrs: {
                                    src: scope.row.imageUrl,
                                    "preview-src-list": [scope.row.imageUrl],
                                    fit: "cover",
                                  },
                                })
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "validityEndTime",
                      label: "项目有效期",
                      width: "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "订单状态", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-tag", { attrs: { size: "small" } }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.orderStatus || "-") +
                                  "\n            "
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "detail-section" },
            [
              _c(
                "div",
                {
                  staticClass: "section-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("交易信息"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("订单金额："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value amount" }, [
                        _vm._v(
                          "\n              ¥" +
                            _vm._s(_vm.orderDetail.orderTotalAmount) +
                            "\n              "
                        ),
                        _c(
                          "span",
                          { staticClass: "payment-detail" },
                          [
                            _vm._v(
                              "\n                (福豆: ¥" +
                                _vm._s(_vm.orderDetail.integralAmount || 0) +
                                ", 微信: ¥" +
                                _vm._s(_vm.orderDetail.wxPayAmount || 0) +
                                "\n                "
                            ),
                            Number(_vm.orderDetail.oneCardDeductPrice) > 0
                              ? [
                                  _vm._v(
                                    "\n                  , 一卡通权益抵扣: ¥" +
                                      _vm._s(
                                        _vm.orderDetail.oneCardDeductPrice
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(")\n              "),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("优惠券优惠："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value discount" }, [
                        _vm._v(
                          "-¥" + _vm._s(_vm.orderDetail.discountAmount || 0)
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.orderDetail.writeOffTime !== null &&
          _vm.orderDetail.writeOffTime !== undefined
            ? _c(
                "el-card",
                { staticClass: "detail-section", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "section-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", { staticClass: "section-title" }, [
                        _vm._v("核销信息"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("核销门店："),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.orderDetail.writeOffStoreName ||
                                  _vm.orderDetail.storeName ||
                                  "-"
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("操作人："),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.orderDetail.writeOffOperator ||
                                  _vm.orderDetail.operator ||
                                  "-"
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("核销方式："),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.orderDetail.writeOffMethod ||
                                  _vm.orderDetail.writeOffType ||
                                  "-"
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("核销码："),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.orderDetail.writeOffCode ||
                                  _vm.orderDetail.pickupCode ||
                                  "-"
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "detail-section", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "section-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("日志列表"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.orderDetail.logs || [],
                    border: "",
                    size: "small",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "createTime", label: "时间", width: "180" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "title", label: "操作人", width: "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "content",
                      label: "操作日志",
                      "min-width": "300",
                      "show-overflow-tooltip": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [_c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("关闭")])],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }